import axios from "axios";
import { useParams } from "react-router-dom";

// "" (chaine vide) = meme origine en prod -> ?? et non || (|| ecraserait la chaine vide)
const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://127.0.0.1:8000";

const auth = () => `Token ${localStorage.getItem("token")}`;

// Provenance posee par nginx (_2f_ft = premier contact, _2f_lt = dernier contact),
// envoyee telle quelle a l'inscription : l'API est sur un autre domaine et ne voit pas ces cookies.
const lireCookie = (nom) => {
  const m = document.cookie.match(new RegExp("(?:^|; )" + nom + "=([^;]*)"));
  return m ? m[1] : "";
};
const attribution = () => ({ ft: lireCookie("_2f_ft"), lt: lireCookie("_2f_lt") });

export const balanceHistoryCall = () => {
  return axios({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/order/balance_history`,
  });
};
export const getRentListActive = () => {

  return axios({
    method: "GET",
    headers: { 
      "Content-Type": "application/json",
      Authorization: auth()
    },
    url: `${BASE_URL}/order/get_rent_list_active`,
  });
};

export const getRentList = () => {

  return axios({
    method: "GET",
    headers: { 
      "Content-Type": "application/json",
      Authorization: auth()
    },
    url: `${BASE_URL}/order/get_rent_list`,
  });
};


// Pays réellement louables (stock + prix réels côté provider), pas une liste figée.
export const rentCountriesCall = (days = 1) => {
  return axios({
    method: "GET",
    headers: { "Content-Type": "application/json", Authorization: auth() },
    url: `${BASE_URL}/order/rent_countries?time=${days}`,
  });
};

export const appPlaceRent = (time, country) => {
  
  return axios({
    
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/order/app_place_rent`,
    data: {
      country: country,
      time: time,
    },
  });
};

// --- Dépôt via FixedFloat (ff.io) ---
// Le client choisit un montant (ce qui atterrit sur notre wallet) et une crypto ;
// le backend crée un ordre ff.io et renvoie l'adresse de dépôt à laquelle envoyer.
// On ne redirige plus vers une page hébergée : on affiche l'adresse + QR et on
// interroge deposit_status jusqu'au crédit (ff.io n'a pas de webhook).
export const createDepositCall = (amount, pay_currency) => {
  return axios({
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: auth() },
    url: `${BASE_URL}/order/create_deposit`,
    data: { amount, pay_currency },
  });
};

export const depositStatusCall = (order_id) => {
  return axios({
    method: "GET",
    headers: { "Content-Type": "application/json", Authorization: auth() },
    url: `${BASE_URL}/order/deposit_status?order_id=${encodeURIComponent(order_id)}`,
  });
};

export const depositCurrenciesCall = () => {
  return axios({
    method: "GET",
    headers: { "Content-Type": "application/json", Authorization: auth() },
    url: `${BASE_URL}/order/deposit_currencies`,
  });
};

export const orderListCall = () => {
  return axios({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/order/list`,
  });
};

export const cancelCall = (id) => {
  return axios({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/order/cancel/${id}`,
  });
};

export const finishCall = (id) => {
  return axios({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/order/finish/${id}`,
  });
};

// Catalogue complet en UN appel (~64Ko gzip). Remplace les 88 appels paginés :
// le navigateur plafonne à 6 connexions, les 88 requêtes coûtaient ~3,2 s.
export const getServicesCatalog = () => {
  return axios({
    method: "GET",
    url: `${BASE_URL}/order/services_catalog`,
  });
};

// Liste légère des services (paginée, ~3.7Ko/page) — remplace le get_services 8.9Mo
export const getServicesPaginated = (page = 1) => {
  return axios({
    method: "GET",
    url: `${BASE_URL}/order/get_services_paginated?page=${page}`,
  });
};

// Détail d'UN service : pays + providers + prix (~30Ko) — chargé à la demande
export const getServiceByName = (service) => {
  return axios({
    method: "GET",
    url: `${BASE_URL}/order/get_service_by_name?service=${encodeURIComponent(service)}`,
  });
};

export const buyCall = (buyData) => {
  return axios({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/order/app_place`,
    data: buyData,
  });
};

export const changePassCall = (passData) => {
  return axios({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/user/change_password`,
    data: passData,
  });
};

export const keyCall = () => {
  return axios({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/user/key`,
  });
};

export const activeOrdersCall = () => {
  return axios({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/order/list_active`,
  });
};

export const loginCall = (loginData) => {
  return axios({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    url: `${BASE_URL}/user/signin`,
    data: {
      email: loginData.email,
      password: loginData.password,
    },
  });
};
// Connexion par cle de compte seule (sans e-mail ni mot de passe).
export const loginKeyCall = (key) => {
  return axios({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    url: `${BASE_URL}/user/signin-key`,
    data: {
      key: key,
    },
  });
};
export const loginCallWithGoogle = (res) => {
  return axios({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    url: `${BASE_URL}/rest-auth/google/`,
    data: {
      access_token: res.accessToken,
      attribution: attribution(),
    },
  });
};
// loginTokenWithGoogle supprimé : /user/get-token?email= délivrait un jeton sans
// preuve de possession (prise de compte) — endpoint neutralisé côté backend.
// Le login Google légitime passe par loginCallWithGoogle (/rest-auth/google/).

export const verifyEmailCall = (userid, token) => {
  return axios({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    url: `${BASE_URL}/user/verify-email/${token}/${userid}/`,
  });
};

export const signUpCall = (signupData, hcaptcha_response) => {
  return axios({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    url: `${BASE_URL}/user/signup`,
    data: {
      email: signupData.email,
      password: signupData.password,
      confirm_password: signupData.confirm_password,
      passcode: hcaptcha_response,
      attribution: attribution(),
    },
  });
};

// Inscription sans e-mail : le serveur renvoie la cle de compte (a afficher
// une seule fois, elle n'est jamais renvoyee par la suite).
export const signUpKeyCall = (hcaptcha_response) => {
  return axios({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    url: `${BASE_URL}/user/signup-key`,
    data: {
      passcode: hcaptcha_response,
      attribution: attribution(),
    },
  });
};

// export const forgerPassCall = (email) => {
//   return axios({
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     url: `${BASE_URL}/user/reset_password`,
//     data: {
//       email: email,
//     },
//   });
// };

// export const resetPassCall = (pass, token) => {
//   return axios({
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     url: `${BASE_URL}/user/reset_passwordconfirm/?token=${token}`,
//     data: {
//       password: pass.password,
//       token: token,
//     },
//   });
// };

export const getFreeNumbers = () => {
  return axios({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    // Numeros agreges par Django depuis les sites partenaires (orders/free_numbers.py).
    // L'ancien service (app Heroku, puis 127.0.0.1:8001) n'existe plus.
    url: `${BASE_URL}/order/free_numbers`,
  });
};

export const forgerPassCall = (email) => {
  return axios({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    url: `${BASE_URL}/user/forget-password/`,
    data: {
      email: email,
    },
  });
};

export const resetPassCall = (pass, token, userid) => {
  return axios({
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    url: `${BASE_URL}/user/reset-password/${token}/${userid}/`,
    data: {
      password: pass.password,
      confirm_password: pass.confirmPass,
      token: token,
    },
  });
};

export const cancelRentOrder = (id) => {
  return axios({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: auth(),
    },
    url: `${BASE_URL}/order/cancel_place_rent/${id}`
  });
}